"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ButtonMenu = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../baseComponents/Button"));

var _DropMenu = _interopRequireDefault(require("../baseComponents/DropMenu"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../utils/utils");

var _index = require("../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ButtonMenu = function ButtonMenu(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      opened = _useState2[0],
      setOpened = _useState2[1];

  var menuRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (opened) {
      document.addEventListener("click", isTargetDropdown, false);
    } else {
      document.removeEventListener("click", isTargetDropdown, false);
    }

    return function () {
      document.removeEventListener("click", isTargetDropdown, false);
    };
  }, [opened]);

  function handleOpened(e) {
    setOpened(!opened);
  }

  function isTargetDropdown(event) {
    if (!(0, _utils.Contains)(menuRef.current, event.target) && opened) {
      handleOpened();
    }
  }

  function handleOnClick(elClick) {
    if (elClick) {
      elClick();
    }

    handleOpened();
  }

  var isIconOnly = props.withIcon && props.text == null;
  var classes = (0, _classnames["default"])('buttonMenu-component', props.className, props.align, {
    'show': opened,
    "showOverSelf": props.showOverSelf,
    'isIconOnly': isIconOnly
  });
  var options = props.options.map(function (el) {
    return _objectSpread(_objectSpread({}, el), {}, {
      onClick: function onClick() {
        return handleOnClick(el.onClick);
      }
    });
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    colorTheme: props.colorTheme,
    size: props.size,
    text: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.text, " ", props.withIcon && /*#__PURE__*/_react["default"].createElement(_index.Icons, {
      name: props.iconName,
      type: "glyph"
    })),
    shapeStyle: props.shapeStyle,
    radius: props.radius,
    disabled: props.disabled,
    onClick: handleOpened,
    icon: props.withIcon,
    iconPosition: isIconOnly ? null : "right",
    noText: isIconOnly
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "menuContainer",
    ref: menuRef
  }, /*#__PURE__*/_react["default"].createElement(_DropMenu["default"], {
    align: props.align,
    values: options
  })));
};

exports.ButtonMenu = ButtonMenu;
ButtonMenu.Proptypes = {
  //Button props
  colorTheme: _propTypes["default"].oneOf(["teal", "grey", "white", 'red', "purple"]),
  size: _propTypes["default"].oneOf(["xsmall", "small"]),
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  shapeStyle: _propTypes["default"].oneOf(["fill", "stroke"]),
  radius: _propTypes["default"].oneOf(["round", "square"]),
  disabled: _propTypes["default"].bool,
  //Menu props
  align: _propTypes["default"].oneOf(["left", "middle", "right"]),
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    onClick: _propTypes["default"].func,
    className: _propTypes["default"].string,
    style: _propTypes["default"].object,
    value: _propTypes["default"].string,
    disabled: _propTypes["default"].bool,
    selected: _propTypes["default"].bool,
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  })),
  //component props
  showOverSelf: _propTypes["default"].bool,
  withIcon: _propTypes["default"].bool,
  iconName: _propTypes["default"].string
};
ButtonMenu.defaultProps = {
  //Button props
  colorTheme: "teal",
  size: "small",
  text: null,
  shapeStyle: "fill",
  radius: "round",
  disabled: false,
  //Menu props
  align: "left",
  options: [],
  //component props
  className: "",
  withIcon: false,
  iconName: "micro-glyph-arrow-head",
  showOverSelf: false
};
var _default = ButtonMenu;
exports["default"] = _default;